import { render, staticRenderFns } from "./NflFullStats.vue?vue&type=template&id=3d4b2658&scoped=true"
import script from "./NflFullStats.vue?vue&type=script&lang=js"
export * from "./NflFullStats.vue?vue&type=script&lang=js"
import style0 from "./NflFullStats.vue?vue&type=style&index=0&id=3d4b2658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4b2658",
  null
  
)

export default component.exports